(function () {
  'use strict';

  /* Galerie: Wischen auf dem Hauptbild = naechstes / voriges Bild.

     Loest einen Klick auf das passende Mini-Bild aus. Damit laufen
     Bildwechsel, Markierung und srcset-Logik (kis.js gallery() und
     kis-buybox.liquid) ueber exakt denselben Weg wie beim Antippen.
     Am Ende geht es wieder zum ersten Bild (und umgekehrt).

     Wird ueber kis-head pro Abschnitt eingebunden - deshalb die Sperre. */
  if (window.__kisSwipe) return;
  window.__kisSwipe = true;

  function swipe() {
    var stage = document.querySelector('.kisb__stage');
    var thumbs = document.getElementById('kisb-thumbs');
    if (!stage || !thumbs || stage.dataset.kisSwipe) return;
    stage.dataset.kisSwipe = '1';

    /* Senkrecht scrollen bleibt beim Browser, waagrecht uebernehmen wir. */
    stage.style.touchAction = 'pan-y pinch-zoom';

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function list() { return Array.prototype.slice.call(thumbs.querySelectorAll('.kisb__thumb')); }
    function current(l) {
      for (var i = 0; i < l.length; i++) { if (l[i].getAttribute('aria-current') === 'true') return i; }
      return 0;
    }
    function center(btn) {
      var u = thumbs.getBoundingClientRect(), r = btn.getBoundingClientRect();
      var x = thumbs.scrollLeft + (r.left - u.left) - (thumbs.clientWidth - r.width) / 2;
      if (thumbs.scrollTo) { thumbs.scrollTo({ left: x, behavior: 'smooth' }); } else { thumbs.scrollLeft = x; }
    }
    function preload(btn) {
      if (!btn) return;
      var im = new Image();
      im.src = btn.getAttribute('data-src');
    }

    function go(dir) {
      var l = list();
      if (l.length < 2) return;
      var i = (current(l) + dir + l.length) % l.length;
      var img = document.getElementById('kisb-main');

      /* Kurzes Einschieben aus der Wischrichtung, sobald das neue Bild da ist */
      if (img && !reduce && img.animate) {
        var done = false;
        var play = function () {
          if (done) return;
          done = true;
          img.removeEventListener('load', play);
          img.animate(
            [{ opacity: 0.4, transform: 'translateX(' + (dir > 0 ? 28 : -28) + 'px)' }, { opacity: 1, transform: 'none' }],
            { duration: 260, easing: 'ease-out' }
          );
        };
        img.addEventListener('load', play);
        setTimeout(play, 400);
      }

      l[i].click();
      center(l[i]);
      preload(l[(i + dir + l.length) % l.length]);
    }

    var x0 = null, y0 = 0;
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      /* mind. 35 px und klar waagrecht - sonst war es Scrollen */
      if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.2) { go(dx < 0 ? 1 : -1); }
    }, { passive: true });
    stage.addEventListener('touchcancel', function () { x0 = null; }, { passive: true });

    /* Pfeile + Zaehler (03.10.): Pfeile nutzen denselben Weg wie das Wischen */
    stage.querySelectorAll('[data-kis-nav]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        go(parseInt(b.getAttribute('data-kis-nav'), 10) || 1);
      });
    });
    var cnt = document.getElementById('kisb-count');
    function count() {
      var l = list();
      if (!cnt) return;
      if (l.length < 2) { cnt.hidden = true; return; }
      cnt.textContent = (current(l) + 1) + ' / ' + l.length;
    }
    count();
    if (window.MutationObserver) {
      new MutationObserver(count).observe(thumbs, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
    }
    if (list().length < 2) {
      stage.querySelectorAll('[data-kis-nav]').forEach(function (b) { b.hidden = true; });
    }
    /* Tastatur: Pfeiltasten, wenn die Galerie im Fokus ist */
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });

    /* Nachbarbild vorladen, damit der erste Wisch sofort sitzt */
    var l0 = list();
    if (l0.length > 1) { preload(l0[(current(l0) + 1) % l0.length]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', swipe);
  } else { swipe(); }
  document.addEventListener('shopify:section:load', swipe);
})();
